import { lazy } from 'react';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';

const ClinicList = lazy(() => import('@pages/ClinicList'));
const AddClinic = lazy(() => import('@pages/AddClinic'));
const EditClinic = lazy(() => import('@pages/EditClinic'));
const SeoScript = lazy(() => import('@pages/SeoScript/index'));
const RankCheck = lazy(() => import('@pages/RankCheck/index'));
const TeamReport = lazy(() => import('@pages/TeamReport/index'));
const FreshdeskReport = lazy(() => import('@pages/FreshdeskReport/index'));
const MyWork = lazy(() => import('@pages/MyWork/index'));
const ChangeTracker = lazy(() => import('@pages/ChangeTracker/index'));
const GmbReviews = lazy(() => import('@pages/GmbReviews/index'));
const ChangePassword = lazy(() => import('@pages/ChangePassword'));

export const roles = {
  SUPER_ADMIN: 'super admin'
};

/** Default page after login or visiting `/` while authenticated. */
export const DEFAULT_HOME_ROUTE = '/rank-check';

export const menu = [
  {
    icon: 'plus',
    name: 'Add Clinic',
    link: '/clinics/add',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <AddClinic />
  },
  {
    icon: 'clinic',
    name: 'Edit Clinic',
    link: '/clinics/:id/edit',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <EditClinic />
  },
  {
    icon: <LocalHospitalOutlinedIcon />,
    name: 'Clinics',
    link: '/clinics',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <ClinicList />
  },
  {
    icon: <ArticleOutlinedIcon />,
    name: 'SEO Script',
    link: '/seo-script',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <SeoScript />
  },
  {
    icon: <CompareArrowsOutlinedIcon />,
    name: 'Change Tracker',
    link: '/change-tracker',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <ChangeTracker />
  },
  {
    icon: <RateReviewOutlinedIcon />,
    name: 'GMB Reviews',
    link: '/gmb-reviews',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <GmbReviews />
  },
  {
    icon: <PersonOutlineOutlinedIcon />,
    name: 'My Work',
    link: '/my-work',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <MyWork />
  },
  {
    icon: <TrendingUpOutlinedIcon />,
    name: 'Rank Check',
    link: '/rank-check',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <RankCheck />
  },
  {
    icon: <AssessmentOutlinedIcon />,
    name: 'Team Report',
    link: '/team-report',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <TeamReport />
  },
  {
    icon: <ConfirmationNumberOutlinedIcon />,
    name: 'Freshdesk',
    link: '/freshdesk',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [roles.SUPER_ADMIN],
    component: <FreshdeskReport />
  },
  {
    icon: 'user',
    name: 'Change Password',
    link: '/change-password',
    role: [roles.SUPER_ADMIN],
    isVisibleInSidebar: [],
    component: <ChangePassword />
  }
];

/** Menu items shown in sidebar / mobile bottom nav (excludes add/edit/password routes). */
export function getVisibleSidebarMenuItems(userRole) {
  const role = (userRole || '').toLowerCase();
  return menu.filter(
    (item) =>
      item.link &&
      item.isVisibleInSidebar.includes(role) &&
      item.role.includes(role)
  );
}
